import "./Report.scss";
import React from "react";
import { getReportbyAircraft, getReportbyFlight, getStats } from "../../../components/Axios/Axios";
import useFileDownload from "../../../hooks/useFileDownload";
function Report() {
  const [rangeFilter, setRangeFilter] = React.useState(false);
  const [byAircraft, setByAircraft] = React.useState(false);
  const [byFlight, setByFlight] = React.useState(false);
  const [startDate, setStartDate] = React.useState("");
  const [endDate, setEndDate] = React.useState("");
  const [totalHours, setTotalHours] = React.useState("");
  const [day, setDay] = React.useState("")
  const [night, setNight] = React.useState("")
  const [pic, setPic] = React.useState("")
  const [sic, setSic] = React.useState("")
  const [crossCountry, setCrossCountry] = React.useState("")
  const [asInstructor, setAsInstructor] = React.useState("")
  const [complex, setComplex] = React.useState("");
  const [pressurized, setPressurized] = React.useState("");
  const [retractable, setRetractable] = React.useState("");
  const [highPerformance, setHighPerformance] = React.useState("");
  const [amphibian, setAmphibian] = React.useState("");
  const [skis, setSkis] = React.useState("");

  const downloadFile = useFileDownload()
  //Generate Report Function
  const handleFlightReport = async () => {
    if (byFlight === true) {
      try {
        const data = {
          start_date: startDate,
          end_date: endDate
        }
        const url = await getReportbyFlight(data);
        if (url) {
          downloadFile(url, "report.pdf");
        }
      }
      catch (error) {
        console.error("Error adding flight", error);
      }
    }
    else {
      const url = await getReportbyAircraft();
      if (url) {
        downloadFile(url, "report.pdf");
      }
    }
  }

  const handleByFlight = () => {
    setByFlight(true);
    setByAircraft(false);
  }

  const handleByAircraft = () => {
    setByFlight(false);
    setByAircraft(true);
  }


  const selectByFlight = () => {
    if (byFlight === true) {
      setRangeFilter(false);
    }

    if (byAircraft === true) {
      setRangeFilter(true)
    }
    // else{
    //   setRangeFilter(true)
    // }
  }

  //Stats Function
  const fetchStats = async () => {

    try {
      const data = await getStats();
      console.log("stats", data)
      setTotalHours(data.filight.filightStats[0].totalHours.toFixed(2));
      setDay(data.filight.filightStats[0].day.toFixed(2));
      setNight(data.filight.filightStats[0].night.toFixed(2))
      setPic(data.filight.filightStats[0].pic.toFixed(2))
      setSic(data.filight.filightStats[0].sic.toFixed(2))
      setCrossCountry(data.filight.filightStats[0].crossCountry.toFixed(2))
      setAsInstructor(data.filight.filightStats[0].ActlInst.toFixed(2))
      setComplex(data.filight.characteristic[0].complex.toFixed(2))
      setPressurized(data.filight.characteristic[0].pressurized.toFixed(2))
      setRetractable(data.filight.characteristic[0].retractable.toFixed(2))
      setHighPerformance(data.filight.characteristic[0].highPerformance.toFixed(2))
      setAmphibian(data.filight.characteristic[0].amphibian.toFixed(2))
      setSkis(data.filight.characteristic[0].skis.toFixed(2))
    }
    catch (error) {
      console.error("Error adding flight", error);
    }

  }

  React.useEffect(() => {
    fetchStats();
  }, []);



  return (
    <div className="dashboard">
      <section
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h4 className="dashboard_heading">Pilot Logbook Report</h4>
        <h6 className="dashboard_subheading">Dashboard {">"} Report</h6>
      </section>
      <div style={{ display: "flex", marginBottom: "4%" }}>
        <section className="right_container">
          <h4 className="heading3">Filters</h4>
          <h5 className="heading4">Report Type</h5>
          <div
            style={{
              display: "flex",
              gap: "10%",
              flexWrap: "wrap",
              marginTop: "4%",
            }}
          >
            {/* <label className="heading5 radio_btn">
              <input type="radio" name="reportOption" />
              All Flights
            </label> */}
            <label className="heading5 radio_btn">
              <input type="radio" name="reportOption" onClick={selectByFlight} onChange={handleByAircraft} />
              By Aircraft
            </label>
            <label className="heading5 radio_btn">
              <input type="radio" name="reportOption" onClick={selectByFlight} onChange={handleByFlight} />
              By Flight
            </label>

            {/* <label className="heading5 radio_btn">
              <input type="radio" name="reportOption" />
              By Countries
            </label> */}
          </div>
          {rangeFilter ? (<div><h5 className="heading4" style={{ marginTop: "4%" }}>
            Select Date Range
          </h5>
            <label className="heading5" style={{ marginTop: "2%", display: "inline-flex", width: "100%", alignItems: "center" }}>
              From
              <input
                type="date"
                placeholder="Select"
                className="date_input"
                onChange={(e) => setStartDate(e.target.value)}
                value={startDate}
              />
            </label>
            <label
              className="heading5"
              style={{ marginTop: "6%", marginLeft: "2%", display: "inline-flex", width: "100%", alignItems: "center" }}
            >
              To
              <input
                type="date"
                placeholder="Select"
                className="date_input"
                style={{ marginLeft: "23px" }}
                onChange={(e) => setEndDate(e.target.value)}
                value={endDate}
              />
            </label></div>) : (<div></div>)}
          <div style={{ marginTop: "6%" }}>
            <a className="heading4" style={{ color: "black", marginTop: "8%" }}>
              Clear Filter
            </a>
          </div>
          <button onClick={handleFlightReport} style={{ marginTop: "6%", marginBottom: "50%" }} className="generate_btn">Generate</button>
          {/* <h4 className="heading3" style={{ marginTop: "6%" }}>
            Export Report
          </h4>
          <div style={{ display: "flex", gap: "10%", flexWrap: "wrap",marginTop: "4%" }}>
            <label className="heading5 radio_btn">
              <input type="radio" name="reportOption" />
              PDF
            </label>
            <label className="heading5 radio_btn">
              <input type="radio" name="reportOption" />
              CSV
            </label>
          </div>
          <button className="export_btn">Export</button> */}
        </section>
        <section className="left_container">
          <h4 className="heading3">Report</h4>
          <h5 className="heading4">Overview</h5>
          <section className="dash_count_section">
            <div className="dash_count">
              <h4>Total Hours</h4>
              <h3 className="dash_numb">{totalHours}</h3>
            </div>
            <div className="dash_count">
              <h4>Day</h4>
              <h3 className="dash_numb">{day}</h3>
            </div>
            <div className="dash_count">
              <h4>Night</h4>
              <h3 className="dash_numb">{night}</h3>
            </div>
            <div className="dash_count">
              <h4>PIC</h4>
              <h3 className="dash_numb">{pic}</h3>
            </div>
            <div className="dash_count">
              <h4>SIC</h4>
              <h3 className="dash_numb">{sic}</h3>
            </div>
          </section>
          <div style={{ display: "flex", gap: "5%", marginTop: "2%" }}>
            <h5 className="heading4" style={{ width: "45%" }}>Standard Time </h5>
            <h5 className="heading4">Times Aircraft Features </h5>
          </div>
          <div style={{ display: "flex", gap: "10%" }}>
            {/* Table 1 */}
            <div className="r_table">
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr className="t_row">
                    <td>Cross Country</td>
                    <td>{crossCountry}</td>
                  </tr>
                  <tr className="t_row">
                    <td>Night</td>
                    <td>{night}</td>
                  </tr>
                  <tr className="t_row">
                    <td>Instructor</td>
                    <td>{asInstructor}</td>
                  </tr>
                  <tr className="t_row">
                    <td>Day</td>
                    <td>{day}</td>
                  </tr>
                  <tr className="t_row">
                    <td>Pic</td>
                    <td>{pic}</td>
                  </tr>
                  <tr className="t_row">
                    <td>Sic</td>
                    <td>{sic}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            {/* Table 2 */}
            <div className="r_table">
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr className="t_row">
                    <td>Complex</td>
                    <td>{complex}</td>
                  </tr>
                  <tr className="t_row">
                    <td>Pressurized</td>
                    <td>{pressurized}</td>
                  </tr>
                  <tr className="t_row">
                    <td>Retractable</td>
                    <td>{retractable}</td>
                  </tr>
                  <tr className="t_row">
                    <td>High Performance</td>
                    <td>{highPerformance}</td>
                  </tr>
                  <tr className="t_row">
                    <td>Amphibian</td>
                    <td>{amphibian}</td>
                  </tr>
                  <tr className="t_row">
                    <td>Skis</td>
                    <td>{skis}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Report;
